export default {
	"monitoringStrategy": {
		"headerTips": "ลากเพื่อปรับลำดับความสำคัญ",
		"addTitle": "เพิ่มนโยบายการควบคุมอุณหภูมิ",
		"importantMonitor": "มุ่งเน้นที่การควบคุมหรือไม่",
		"needTrackable": "อุณหภูมิต้องสามารถติดตามผลได้",
		"needWarning": "ควบคุมหรือไม่",
		"needPickupGoodsTemperature": "ต้องมีอุณหภูมิการจัดส่งสินค้า",
		"needDeliveryGoodsTemperature": "ต้องมีอุณหภูมิในการรับสินค้า",
		"needPickupVehicleTemperature": "ต้องมีอุณหภูมิรถบรรทุก",
		"trackingRequirements": "ข้อกำหนดในการติดตามผล",
		"monitoringObject": "วัตถุที่ควบคุม",
		"priority": "ลำดับความสำคัญ",
		"originStationType": "ประเภทสถานีต้นทาง",
		"destStationType": "ประเภทสถานีปลายทาง",
		"log": "บันทึกการทำงาน",
		"onlyEnableStrategyTypeSelectTips": "สามารถเลือกได้เฉพาะนโยบายการควบคุมในสถานะเปิดใช้งานเท่านั้น"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/monitoringStrategy/monitoringStrategy.js